import gql from 'graphql-tag'

export const SEARCH_NAME_QUERY = gql`
  query SearchNameQuery(
    $text: String!
    $sex: String
    $genderNeutral: Boolean
    $offset: Int!
    $limit: Int!
  ) {
    searchNames(
      text: $text
      sex: $sex
      genderNeutral: $genderNeutral
      start: $offset
      limit: $limit
    ) {
      names {
        id
        name
        sex
        gender_neutral
      }
    }
  }
`

export const BROWSE_NAME_QUERY = gql`
  query BrowseNamesQuery(
    $text: String!
    $sex: String
    $genderNeutral: Boolean
    $offset: Int!
    $limit: Int
  ) {
    browseNames(
      text: $text
      sex: $sex
      genderNeutral: $genderNeutral
      start: $offset
      limit: $limit
    ) {
      id
      name
      sex
      gender_neutral
    }
  }
`

export const NAME_PAGE_QUERY = gql`
  query NamePageQuery($nameId: ID!, $name: String) {
    nameMatches: names(where: { name: $name }) {
      id
      name
      sex
    }
    name(id: $nameId) {
      name
      sex
      origin
      root_name {
        name
        origin
      }
      pronunciation
      gender_neutral
      global_popularity: name_popularity(
        where: { rank_null: false, country: { id_ne: 236 } }
        sort: "year:desc,rank:asc"
        limit: 20
      ) {
        id
        rank
        year
        country {
          name
          alpha3
          flag {
            url
          }
        }
        state {
          name
          code
        }
      }

      us_popularity_detail: name_popularity(
        where: { country: { id: 236 } }
        sort: "year:desc"
        limit: 1
      ) {
        country {
          name
          flag {
            url
          }
        }
      }

      us_popularity: name_popularity(where: { country: { id: 236 } }, sort: "year:asc") {
        id
        count
        rank
        year
      }

      historic_name_wikis {
        body
      }

      related_names {
        id
        name
        sex
      }

      nickname_wikis(limit: 10) {
        body
      }

      siblings(limit: 11, sort: "count:desc", where: { siblingNameRecord_null: false }) {
        name
        count
        siblingNameRecord {
          id
          sex
          published_at
        }
      }

      celebrities {
        full_name
        parents {
          id
        }
        description
      }

      celebrity_children: celebrities(where: { parents_null: false }) {
        full_name
        parents {
          full_name
        }
        description
      }

      media_name_wikis {
        body
      }
    }
  }
`

export const POPULARITY_DETAIL_QUERY = gql`
  query PopularityDetailQuery($country: String, $year: Int, $state: String, $language: String) {
    M: yearsByList(country: $country, sex: "M", state: $state, language: $language)
    F: yearsByList(country: $country, sex: "F", state: $state, language: $language)
    gendersByList(country: $country, year: $year, state: $state, language: $language)
  }
`

const namePopularityListString = sex => {
  return `namePopularityList(
    country: $country
    sex: ${sex}
    year: $year
    state: $state
    language: $language
    start: $offset
    limit: $limit
  ) {
    id
    rank
    count
    year
    country {
      name
    }
    name {
      id
      name
      sex
      gender_neutral
    }
  }`
}

export const POPULARITY_LIST_QUERY = gql`
  query PopularityListQuery(
    $country: String
    $sex: String
    $year: Int
    $state: String
    $language: String
    $offset: Int
    $limit: Int
  ) {
    ${namePopularityListString('$sex')}
  }
`

export const POPULARITY_NON_GENDER_LIST_QUERY = gql`
  query PopularityNonGenderListQuery(
    $country: String
    $year: Int
    $state: String
    $language: String
    $offset: Int
    $limit: Int
  ) {
    M: ${namePopularityListString('"M"')}
    F: ${namePopularityListString('"F"')}
  }
`
